module.exports = __webpack_public_path__ + "media/images/procedure_managements/examples/rules_image-321afb15088c16978cb5a40211e36344.jpg";